import * as React from "react";
import type { SVGProps } from "react";
const SvgNotification = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M6.512 6.845a5.531 5.531 0 0 1 10.976 0l.473 3.78 2.594 3.631C21.973 16.242 20.554 19 18.114 19H5.886c-2.44 0-3.86-2.758-2.44-4.744l.396-.556a1 1 0 0 1 1.628 1.163l-.397.556A1 1 0 0 0 5.886 17h12.228a1 1 0 0 0 .813-1.581L16.485 12h-9.47a1 1 0 0 1-1.007-1.124zM8.132 10h7.735l-.363-2.907a3.531 3.531 0 0 0-7.008 0z"
            clipRule="evenodd"
        />
        <path fill="currentColor" d="M15 22H9v-2h6z" />
    </svg>
);
export default SvgNotification;
